export const maskValues = {
  PAN: (value) => {
    if (!value) return '';
    if (value.length <= 5) return value;
    if (value.length <= 9) return value.slice(0, 5) + '*'.repeat(value.length - 5);
    return `${value.slice(0, 5)}****${value.slice(9, 10)}`;
  },

  CIN: (value) => {
    if (!value) return '';

    const len = value.length;

    if (len <= 5) return value;
    if (len <= 8) return value.slice(0, 5) + '*'.repeat(len - 5);

    return `${value.slice(0, 5)}${'*'.repeat(len - 8)}${value.slice(-3)}`;
  },

  AADHAAR: (value) => {
  if (!value) return '';

  const len = value.length;

  if (len <= 4) return value;

  if (len <= 8) {
    return `${value.slice(0, 4)}${'*'.repeat(len - 4)}`;
  }

  return `${value.slice(0, 4)}${'*'.repeat(len - 8)}${value.slice(-4)}`;
},

  TAN: (value) => {
    if (!value) return '';
    const len = value.length;

    if (len <= 4) return value;
    if (len <= 9) return `${value.slice(0, 4)}${'*'.repeat(len - 4)}`;

    return `${value.slice(0, 4)}${'*'.repeat(len - 5)}${value.slice(-1)}`;
  },

  ACCOUNT: (value) => {
    if (!value) return '';
    const len = value.length;
    if (len <= 4) return value;
    return `${'*'.repeat(len - 4)}${value.slice(-4)}`;
  },

  PASSPORT: (value) => {
    if (!value) return '';
    const len = value.length;

    if (len <= 2) return value;
    if (len <= 8) return value.slice(0, 2) + '*'.repeat(len - 3) + value.slice(-1);

    return `${value.slice(0, 2)}${'*'.repeat(len - 3)}${value.slice(-1)}`;
  },

  VISA: (value) => {
    if (!value) return '';
    const len = value.length;

    if (len <= 3) return value;
    if (len <= 5) return value.slice(0, 3) + '*'.repeat(len - 3);

    return `${value.slice(0, 3)}${'*'.repeat(len - 5)}${value.slice(-2)}`;
  },
};